import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { SketchPicker } from "react-color";
import { useIntl } from "react-intl";
import { Button, Switch, Message, Input } from "../BP2Components";

const TranslationSettings = (props) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [displayColorPicker, setDisplayColorPicker] = useState(false);
   const [settings, setSettings] = useState({
      id: props.id,
      name: props.name,
      visibleAddTranslation: props.visibleAddTranslation,
      visibleDeleteTranslation: props.visibleDeleteTranslation,
      xsWidth: props.xs,
      smWidth: props.sm,
      mdWidth: props.md,
      lgWidth: props.lg,
      xlWidth: props.xl,
      priority: props.priority,
      columns: props.columns,
      backgroundColourHex: props.backgroundColourHex
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };
   const handleSwitchColumns = (checked, column) => {
      props.columns.forEach((col) => {
         if (col.dataIndex === column.dataIndex) {
            column.visible = checked;
         }
      });
      setSettings({ ...settings, columns: props.columns });
   };

   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };
   const handleClose = () => {
      setDisplayColorPicker(false);
   };
   const handleDefaultColor = () => {
      setSettings({ ...settings, backgroundColourHex: "#fff" });
   };
   const handleChangeColor = (color) => {
      setSettings({ ...settings, backgroundColourHex: color.hex });
   };
   const handleClick = () => {
      setDisplayColorPicker(!displayColorPicker);
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  {props?.columns?.map((column) => (
                     <label key={column.dataIndex} className="widget-settings__inner__label">
                        <p>{"visible " + column.dataIndex}</p>
                        <Switch
                           onChange={(e) => handleSwitchColumns(e, column)}
                           defaultChecked={column.visible}
                        />
                     </label>
                  ))}
                  <label key="visibleAddTranslation" className="widget-settings__inner__label">
                     <IntlMessages id="settings.visibleAddTranslation" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "visibleAddTranslation")}
                        defaultChecked={props.visibleAddTranslation}
                     />
                  </label>{" "}
                  <label key="visibleDeleteTranslation" className="widget-settings__inner__label">
                     <IntlMessages id="settings.visibleDeleteTranslation" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "visibleDeleteTranslation")}
                        defaultChecked={props.visibleDeleteTranslation}
                     />
                  </label>
                  <label key="xsWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.xsWidth" />:
                     <Input
                        type="number"
                        name="xsWidth"
                        onChange={handleChangeInput("xsWidth")}
                        min={1}
                        max={24}
                        defaultValue={props.xs}
                     />
                  </label>
                  <label key="smWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.smWidth" />:
                     <Input
                        type="number"
                        name="smWidth"
                        onChange={handleChangeInput("smWidth")}
                        min={1}
                        max={24}
                        defaultValue={props.sm}
                     />
                  </label>
                  <label key="mdWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.mdWidth" />:
                     <Input
                        type="number"
                        name="mdWidth"
                        onChange={handleChangeInput("mdWidth")}
                        min={1}
                        max={24}
                        defaultValue={props.md}
                     />
                  </label>
                  <label key="lgWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.lgWidth" />:
                     <Input
                        type="number"
                        name="lgWidth"
                        onChange={handleChangeInput("lgWidth")}
                        min={1}
                        max={24}
                        defaultValue={props.lg}
                     />
                  </label>
                  <label key="xlWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.xlWidth" />:
                     <Input
                        type="number"
                        name="xlWidth"
                        onChange={handleChangeInput("xlWidth")}
                        min={1}
                        max={24}
                        defaultValue={props.xl}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="priority">
                     <IntlMessages id="settings.priority" />:
                     <Input
                        type="number"
                        name="priority"
                        onChange={handleChangeInput("priority")}
                        min={1}
                        defaultValue={props.priority}
                     />
                  </label>
                  <label key="backgroundColourHex" className="widget-settings__inner__label">
                     <IntlMessages id="settings.backgroundColour" />:
                     <div>
                        <Button
                           onClick={handleClick}
                           className="cp-color"
                           style={{
                              backgroundColor: settings.backgroundColourHex
                              //  height: 20,
                              // borderRadius: "2px",
                              //  width: "50%",
                           }}
                        >
                           <IntlMessages id="settings.clickToChangeColor" />
                        </Button>
                        <Button onClick={handleDefaultColor}>
                           <IntlMessages id="settings.setDefaultColor" />
                        </Button>
                     </div>
                     {displayColorPicker ? (
                        <div className="cp-popover">
                           <div className="cp-cover" onClick={handleClose} />
                           <SketchPicker
                              color={settings.backgroundColourHex}
                              onChange={handleChangeColor}
                           />
                        </div>
                     ) : null}
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.save" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default TranslationSettings;
